import Tippy from '@tippyjs/react';

import Icon from 'components/shared/Icon/Icon';

export const formatOption = ({ props, handleRemoveOption = () => null }) => {
  const { label, value, meta } = props;

  return (
    <div className="relative flex w-full justify-between" data-qa={`form-option-${label}`}>
      <span className="overflow-hidden text-ellipsis text-left">{label}</span>
      {!props.__isNew__ && (
        <Tippy
          disabled={meta?.practice_id}
          className="tippy-dark"
          content="Cannot modify this form as it is not a custom type.">
          <div>
            <Icon
              disabled={!meta?.practice_id}
              icon="trash-mono"
              onClick={(event) => handleRemoveOption({ event, id: value })}
              data-qa={`form-option-remove-${label}`}
            />
          </div>
        </Tippy>
      )}
    </div>
  );
};

export const formatCreateLabel = ({ inputValue = null, setCreateModalProps = () => null }) => {
  return (
    <div onClick={() => setCreateModalProps({ open: true })} data-qa="form-create-new">
      <span className="text-sm font-400 leading-[22px] text-neutral-900">
        Create a form for "<em className="font-600 italic">{inputValue}</em>"
      </span>
    </div>
  );
};
